import { RefObject, useEffect } from 'react';

/**
 * 监听鼠标是否在指定区域点击
 * @param refs 指定区域
 * @param active 监听事件加载的时机
 * @param handler 监听方法回调
 */
function useClickOutside(
  refs: RefObject<HTMLElement> | RefObject<HTMLElement>[],
  active: boolean,
  handler: Function,
) {
  useEffect(() => { 
    const listener = (event: MouseEvent) => {
      // @ts-ignore
      const eventTarget = (event.target.shadowRoot && event.composed) ? (event.composedPath()[0] || event.target) : event.target;
      if (Array.isArray(refs)) {
        for (let i = 0; i < refs.length; i++) {
          const ele = refs[i];
          if (
            !ele.current ||
            ele.current.contains(eventTarget as HTMLElement)
          ) {
            return;
          }
        }
      } else {
        if (
          !refs.current ||
          refs.current.contains(eventTarget as HTMLElement)
        ) {
          return;
        }
      }
      handler(event);
    };
    if (active) {
      window.addEventListener('click', listener, true);
    } else {
      window.removeEventListener('click', listener, true);
    }
    return () => {
      window.removeEventListener('click', listener, true);
    };
  }, [refs, handler]);
}

export default useClickOutside;
